import React from 'react';

// Spacer + spinner shown at the top of a pane while pulling to refresh.
export default function PullIndicator({ pull, refreshing, threshold }) {
  if (!pull && !refreshing) return null;
  const ready = pull >= threshold;
  return (
    <div className="ptr-indicator" style={{ height: pull }} aria-hidden="true" data-testid="pull-indicator">
      <span className={`ptr-spinner${refreshing ? ' is-spinning' : ''}${ready ? ' is-ready' : ''}`} />
    </div>
  );
}
